"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var api_internal_contract_js_1 = require("@tableau/api-internal-contract-js");
var ServiceImplBase_1 = require("./ServiceImplBase");
var SizeServiceImpl = /** @class */ (function (_super) {
    __extends(SizeServiceImpl, _super);
    function SizeServiceImpl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SizeServiceImpl.prototype, "serviceName", {
        get: function () {
            return "size-service" /* Size */;
        },
        enumerable: true,
        configurable: true
    });
    SizeServiceImpl.prototype.changeSizeAsync = function (name, newSize) {
        var _a;
        var _b, _c, _d, _e;
        var parameters = (_a = {},
            _a[api_internal_contract_js_1.ParameterId.FunctionName] = 'changeSizeAsync',
            _a[api_internal_contract_js_1.ParameterId.SheetName] = name,
            _a[api_internal_contract_js_1.ParameterId.MinHeight] = ((_b = newSize.minSize) === null || _b === void 0 ? void 0 : _b.height) || 0,
            _a[api_internal_contract_js_1.ParameterId.MinWidth] = ((_c = newSize.minSize) === null || _c === void 0 ? void 0 : _c.width) || 0,
            _a[api_internal_contract_js_1.ParameterId.MaxHeight] = ((_d = newSize.maxSize) === null || _d === void 0 ? void 0 : _d.height) || 0,
            _a[api_internal_contract_js_1.ParameterId.MaxWidth] = ((_e = newSize.maxSize) === null || _e === void 0 ? void 0 : _e.width) || 0,
            _a);
        return this.execute(api_internal_contract_js_1.VerbId.SetSheetSize, parameters).then(function (_response) {
            return;
        });
    };
    return SizeServiceImpl;
}(ServiceImplBase_1.ServiceImplBase));
exports.SizeServiceImpl = SizeServiceImpl;
//# sourceMappingURL=SizeServiceImpl.js.map